import { Document, Page, View, Text, StyleSheet } from '@react-pdf/renderer';

const C = {
  negro:  '#000000',
  gris:   '#555555',
  borde:  '#aaaaaa',
  fondo:  '#f5f5f5',
};

const s = StyleSheet.create({
  page: {
    fontFamily: 'Helvetica',
    fontSize: 9,
    color: C.negro,
    paddingTop: 24,
    paddingBottom: 40,
    paddingHorizontal: 32,
  },

  // ── Cabecera ──────────────────────────────────────────────────
  paginaTop: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginBottom: 8,
  },
  paginaText: { fontSize: 8, color: C.gris },

  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 10,
  },
  empresaBloque: { flex: 1 },
  empresaLinea:  { fontSize: 8.5, marginBottom: 1 },

  facturaBloque: { width: 180 },
  facturaFila: {
    flexDirection: 'row',
    borderWidth: 0.5,
    borderColor: C.borde,
    marginBottom: 4,
  },
  facturaEtiqueta: {
    width: 60,
    paddingVertical: 4,
    paddingHorizontal: 6,
    fontSize: 8.5,
    borderRightWidth: 0.5,
    borderRightColor: C.borde,
  },
  facturaValor: {
    flex: 1,
    paddingVertical: 4,
    paddingHorizontal: 6,
    fontSize: 8.5,
    fontFamily: 'Helvetica-Bold',
  },

  // ── Cliente ───────────────────────────────────────────────────
  clienteBloque: { marginBottom: 10 },
  clienteLinea:  { fontSize: 8.5, marginBottom: 1 },

  // ── Tabla siniestros ──────────────────────────────────────────
  tableHead: {
    flexDirection: 'row',
    borderWidth: 0.5,
    borderColor: C.borde,
    backgroundColor: C.fondo,
    marginBottom: 0,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 0.5,
    borderBottomColor: C.borde,
    borderLeftWidth: 0.5,
    borderLeftColor: C.borde,
    borderRightWidth: 0.5,
    borderRightColor: C.borde,
  },
  thCell: {
    flex: 1,
    paddingVertical: 3,
    paddingHorizontal: 4,
    fontSize: 8,
    fontFamily: 'Helvetica-Bold',
    textAlign: 'center',
    borderRightWidth: 0.5,
    borderRightColor: C.borde,
  },
  thCellLast: {
    flex: 1,
    paddingVertical: 3,
    paddingHorizontal: 4,
    fontSize: 8,
    fontFamily: 'Helvetica-Bold',
    textAlign: 'center',
  },
  tdCell: {
    flex: 1,
    paddingVertical: 2.5,
    paddingHorizontal: 4,
    fontSize: 8,
    borderRightWidth: 0.5,
    borderRightColor: C.borde,
  },
  tdCellLast: {
    flex: 1,
    paddingVertical: 2.5,
    paddingHorizontal: 4,
    fontSize: 8,
  },

  // ── Footer ────────────────────────────────────────────────────
  footer: {
    marginTop: 16,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
  },
  reciboText: { fontSize: 8.5 },
  totalesBloque: { width: 180 },
  totalFila: {
    flexDirection: 'row',
    borderWidth: 0.5,
    borderColor: C.borde,
    marginBottom: -0.5,
  },
  totalEtiqueta: {
    flex: 1,
    paddingVertical: 3,
    paddingHorizontal: 6,
    fontSize: 8.5,
    borderRightWidth: 0.5,
    borderRightColor: C.borde,
  },
  totalValor: {
    width: 75,
    paddingVertical: 3,
    paddingHorizontal: 6,
    fontSize: 8.5,
    textAlign: 'right',
    fontFamily: 'Helvetica-Bold',
  },
});

const fmt = (v) =>
  Number(v ?? 0).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';

const fmtFecha = (d) => {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' });
};

// Agrupa el array en trozos de N elementos
function chunk(arr, n) {
  const result = [];
  for (let i = 0; i < arr.length; i += n) result.push(arr.slice(i, i + n));
  return result;
}

function CabeceraFactura({ numFactura, fecha }) {
  return (
    <>
      <View style={s.header}>
        {/* Datos empresa (izquierda) */}
        <View style={s.empresaBloque}>
          <Text style={s.empresaLinea}>C.I.F. B- 41.801.663</Text>
          <Text style={s.empresaLinea}>Avda. de España 121</Text>
          <Text style={s.empresaLinea}>41.700 Dos Hermanas</Text>
          <Text style={s.empresaLinea}>Tfno. 95 566 26 63</Text>
          <Text style={s.empresaLinea}>Cod. Reparador 9.254</Text>
          <Text style={s.empresaLinea}>email: mondepin@mondepin.es</Text>
        </View>

        {/* Nº Factura + Fecha (derecha) */}
        <View style={s.facturaBloque}>
          <View style={s.facturaFila}>
            <Text style={s.facturaEtiqueta}>Nº Factura</Text>
            <Text style={s.facturaValor}>{numFactura}</Text>
          </View>
          <View style={s.facturaFila}>
            <Text style={s.facturaEtiqueta}>Fecha</Text>
            <Text style={s.facturaValor}>{fmtFecha(fecha)}</Text>
          </View>
        </View>
      </View>

      {/* Cliente */}
      <View style={s.clienteBloque}>
        <Text style={s.clienteLinea}>Cliente: Ocaso S.A. Seguros y Reaseguros</Text>
        <Text style={s.clienteLinea}>Princesa nº 23  C.I.F. A - 28.016.608</Text>
        <Text style={s.clienteLinea}>28008 Madrid</Text>
      </View>
    </>
  );
}

export default function FacturaPdf({ factura }) {
  const { numFactura, fecha, lineas, importeTotal, ivaTotal, totalTotal } = factura;

  // Cada fila de la tabla muestra hasta 3 pares (siniestro | póliza)
  const filas = chunk(lineas, 3);

  return (
    <Document title={`Factura ${numFactura} - Mondepin`}>
      <Page size="A4" style={s.page}>

        {/* Cabecera + número de página, repetidos en cada página */}
        <View fixed>
          <View style={s.paginaTop}>
            <Text
              style={s.paginaText}
              render={({ pageNumber, totalPages }) => `Página ${pageNumber} de ${totalPages}`}
            />
          </View>
          <CabeceraFactura numFactura={numFactura} fecha={fecha} />
        </View>

        {/* ── Tabla siniestros ── */}
        <View style={s.tableHead}>
          {[0, 1, 2].map(col => {
            const isLast = col === 2;
            const groupBg = col % 2 === 0 ? C.fondo : '#e8e8e8';
            const sepStyle = !isLast
              ? { borderRightWidth: 2, borderRightColor: C.borde }
              : {};
            return (
              <View key={col} style={{ flex: 1, flexDirection: 'row', backgroundColor: groupBg, ...sepStyle }}>
                <Text style={{ ...s.thCell, flex: 1.4 }}>Siniestro</Text>
                <Text style={isLast ? { ...s.thCellLast } : { ...s.thCell }}>Póliza</Text>
              </View>
            );
          })}
        </View>

        {filas.map((fila, i) => (
          <View key={i} style={s.tableRow} wrap={false}>
            {[0, 1, 2].map(col => {
              const linea  = fila[col];
              const isLast = col === 2;
              const groupBg = col % 2 === 0 ? '#ffffff' : '#f5f5f5';
              const sepStyle = !isLast
                ? { borderRightWidth: 2, borderRightColor: C.borde }
                : {};
              return (
                <View key={col} style={{ flex: 1, flexDirection: 'row', backgroundColor: groupBg, ...sepStyle }}>
                  <Text style={{ ...s.tdCell, flex: 1.4 }}>
                    {linea ? (linea.nSiniestro || `#${linea.codSiniestro}`) : ''}
                  </Text>
                  <Text style={isLast ? { ...s.tdCellLast } : { ...s.tdCell }}>
                    {linea ? (linea.codPoliza || '') : ''}
                  </Text>
                </View>
              );
            })}
          </View>
        ))}

        {/* ── Pie ── */}
        <View style={s.footer}>
          <Text style={s.reciboText}>Recibido de Ocaso  S.A. Seguros y Reaseguros</Text>
          <View style={s.totalesBloque}>
            <View style={s.totalFila}>
              <Text style={s.totalEtiqueta}>Base Imponible</Text>
              <Text style={s.totalValor}>{fmt(importeTotal)}</Text>
            </View>
            <View style={s.totalFila}>
              <Text style={s.totalEtiqueta}>IVA</Text>
              <Text style={s.totalValor}>{fmt(ivaTotal)}</Text>
            </View>
            <View style={s.totalFila}>
              <Text style={s.totalEtiqueta}>Total</Text>
              <Text style={s.totalValor}>{fmt(totalTotal)}</Text>
            </View>
          </View>
        </View>

      </Page>
    </Document>
  );
}
